export default class RevealHero extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  initFruitData($el) {
    const data = $el.dataset;
    //For the reveal-hero, we scale the fruit position on reveal
    const scale = 0.35;
    const size = parseInt(data.size);

    const x = parseInt(data.x);
    const cx = data.xSetting == "from-left" ? x + size / 2 : x - size / 2;
    const dx = cx - 50;
    const newX = x + scale * dx;

    const y = parseInt(data.y);
    const cy = data.ySetting == "from-top" ? y + size / 2 : y - size / 2;
    const dy = cy - 50;
    const newY = y + scale * dy;

    $el.dataset.xTo = newX;
    $el.dataset.yTo = newY;
  }

  init() {
    // if (document.body.classList.contains("design-mode")) return;

    let scrollTl = gsap.timeline({
      scrollTrigger: {
        trigger: this.querySelector(".reveal-hero"),
        //Pinned scroll scene:
        pin: true,
        start: "top top",
        end: "+=200%",
        scrub: true,
      },
    });

    //Each fruit moves
    this.querySelectorAll('fruit-element').forEach((fruit) => {
      this.initFruitData(fruit);

      const xDir = fruit.dataset.xSetting == "from-left" ? 'left' : 'right';
      const yDir = fruit.dataset.ySetting == "from-top" ? "top" : "bottom";

      scrollTl.to(
        fruit,
        // {
        //   [xDir]: `${fruit.dataset.x}%`,
        //   [yDir]: `${fruit.dataset.y}%`,
        // },
        {
          [xDir]: `${fruit.dataset.xTo}%`,
          [yDir]: `${fruit.dataset.yTo}%`,
        },
        0
      );
    });

    //Reveal hero text
    scrollTl.to(this.querySelector(".reveal-hero__subheader"), {
      height: '100%'
    }, 0);
  }
}
customElements.define("reveal-hero", RevealHero);
